export default __webpack_public_path__ + "static/media/fp-dropdown.d9ac1569.webp";